import React, { useState, useEffect } from 'react'
import { fetchCities, addCity, updateCity, deleteCity } from '../lib/api'
import SpecialBadge from './SpecialBadge'

const TIMEZONES = [
  { label: 'Нью-Йорк (UTC-5/-4)', value: 'America/New_York' },
  { label: 'Богота / Лима (UTC-5)', value: 'America/Bogota' },
  { label: 'Буэнос-Айрес (UTC-3)', value: 'America/Argentina/Buenos_Aires' },
  { label: 'Лондон (UTC+0/+1)', value: 'Europe/London' },
  { label: 'Лагос (UTC+1)', value: 'Africa/Lagos' },
  { label: 'Берлин (UTC+1/+2)', value: 'Europe/Berlin' },
  { label: 'Каир (UTC+2/+3)', value: 'Africa/Cairo' },
  { label: 'Харare (UTC+2)', value: 'Africa/Harare' },
  { label: 'Йоханнесбург (UTC+2)', value: 'Africa/Johannesburg' },
  { label: 'Москва (UTC+3)', value: 'Europe/Moscow' },
  { label: 'Стамбул (UTC+3)', value: 'Europe/Istanbul' },
  { label: 'Найроби (UTC+3)', value: 'Africa/Nairobi' },
  { label: 'Аддис-Абеба (UTC+3)', value: 'Africa/Addis_Ababa' },
  { label: 'Дубай (UTC+4)', value: 'Asia/Dubai' },
  { label: 'Ташкент (UTC+5)', value: 'Asia/Tashkent' },
  { label: 'Дакка (UTC+6)', value: 'Asia/Dhaka' },
  { label: 'Алматы / Омск (UTC+6)', value: 'Asia/Almaty' },
  { label: 'Бангкок (UTC+7)', value: 'Asia/Bangkok' },
  { label: 'Манила (UTC+8)', value: 'Asia/Manila' },
  { label: 'Гонконг (UTC+8)', value: 'Asia/Hong_Kong' },
  { label: 'Пекин (UTC+8)', value: 'Asia/Shanghai' },
  { label: 'Токио (UTC+9)', value: 'Asia/Tokyo' },
  { label: 'Сидней (UTC+10/+11)', value: 'Australia/Sydney' },
]

export default function CitiesPage({ onClose, darkMode }) {
  const [cities, setCities] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [editId, setEditId] = useState(null)
  const [editName, setEditName] = useState('')
  const [editTz, setEditTz] = useState('')
  const [newName, setNewName] = useState('')
  const [newTz, setNewTz] = useState('Africa/Harare')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    fetchCities().then(data => { setCities(data); setLoading(false) })
  }, [])

  const filtered = cities.filter(c => c.name.toLowerCase().includes(search.toLowerCase()))

  async function handleAdd() {
    if (!newName.trim()) return
    const duplicate = cities.find(c => c.name.trim().toLowerCase() === newName.trim().toLowerCase())
    if (duplicate) { alert(`Город «${duplicate.name}» уже есть в справочнике`); return }
    setSaving(true)
    try {
      const city = await addCity(newName.trim(), newTz)
      setCities(prev => [...prev, city].sort((a, b) => a.name.localeCompare(b.name)))
      setNewName('')
      setNewTz('Africa/Harare')
    } catch (e) { alert('Ошибка: ' + e.message) }
    setSaving(false)
  }

  async function handleSaveEdit(id) {
    if (!editName.trim()) return
    try {
      await updateCity(id, { name: editName.trim(), timezone: editTz })
      setCities(prev => prev.map(c => c.id === id ? { ...c, name: editName.trim(), timezone: editTz } : c).sort((a, b) => a.name.localeCompare(b.name)))
      setEditId(null)
    } catch (e) { alert('Ошибка: ' + e.message) }
  }

  async function handleDelete(id, name) {
    if (!window.confirm('Удалить город "' + name + '"?')) return
    try {
      await deleteCity(id)
      setCities(prev => prev.filter(c => c.id !== id))
    } catch (e) { alert('Ошибка: ' + e.message) }
  }

  function startEdit(city) {
    setEditId(city.id)
    setEditName(city.name)
    setEditTz(city.timezone)
  }

  const tzLabel = (value) => {
    const tz = TIMEZONES.find(t => t.value === value)
    return tz ? tz.label : value
  }

  return (
    <div className="cities-page" style={{ minHeight: '100vh', background: '#f5f5f3' }}>
      <header style={{ background: 'white', borderBottom: '1px solid #e8e8e5', padding: '0 24px', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ maxWidth: 800, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 60 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button onClick={onClose} style={{ background: 'transparent', border: 'none', cursor: 'pointer', fontSize: 20, color: '#888', padding: '4px 8px' }}>←</button>
            <h1 style={{ fontSize: 17, fontWeight: 600 }}>Справочник городов</h1><SpecialBadge />
          </div>
          <span style={{ fontSize: 13, color: '#888' }}>{cities.length} городов</span>
        </div>
      </header>

      <main style={{ maxWidth: 800, margin: '0 auto', padding: '24px' }}>

        <div className="cities-card" style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, padding: '16px 20px', marginBottom: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12 }}>Добавить новый город</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 10, alignItems: 'end' }}>
            <div>
              <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Название</label>
              <input value={newName} onChange={e => setNewName(e.target.value)} placeholder="Гверу" onKeyDown={e => e.key === 'Enter' && handleAdd()}
                style={{ width: '100%', fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }} />
            </div>
            <div>
              <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Часовой пояс</label>
              <select value={newTz} onChange={e => setNewTz(e.target.value)}
                style={{ width: '100%', fontSize: 13, padding: '7px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
                {TIMEZONES.map(tz => <option key={tz.value} value={tz.value}>{tz.label}</option>)}
              </select>
            </div>
            <button onClick={handleAdd} disabled={saving || !newName.trim()}
              style={{ padding: '7px 16px', borderRadius: 8, background: '#1a1a1a', color: 'white', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap' }}>
              + Добавить
            </button>
          </div>
        </div>

        <div className="cities-card" style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, overflow: 'hidden' }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0ec' }}>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Поиск по названию..."
              style={{ width: '100%', fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc', background: '#fafaf8' }} />
          </div>

          {loading && <div style={{ padding: 24, textAlign: 'center', color: '#888', fontSize: 13 }}>Загрузка...</div>}

          {filtered.map((city, i) => (
            <div key={city.id} className="city-row" style={{ borderBottom: i < filtered.length - 1 ? '1px solid #f5f5f3' : 'none' }}>
              {editId === city.id ? (
                <div className="city-edit-row" style={{ padding: '12px 16px', background: '#f9f9f7' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto auto', gap: 8, alignItems: 'center' }}>
                    <input value={editName} onChange={e => setEditName(e.target.value)}
                      style={{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #378ADD' }} />
                    <select value={editTz} onChange={e => setEditTz(e.target.value)}
                      style={{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #e0e0dc' }}>
                      {TIMEZONES.map(tz => <option key={tz.value} value={tz.value}>{tz.label}</option>)}
                    </select>
                    <button onClick={() => handleSaveEdit(city.id)}
                      style={{ padding: '6px 12px', borderRadius: 8, background: '#1a1a1a', color: 'white', border: 'none', cursor: 'pointer', fontSize: 12 }}>
                      Сохранить
                    </button>
                    <button onClick={() => setEditId(null)}
                      style={{ padding: '6px 10px', borderRadius: 8, background: 'transparent', border: '1px solid #e0e0dc', cursor: 'pointer', fontSize: 12, color: '#888' }}>
                      Отмена
                    </button>
                  </div>
                </div>
              ) : (
                <div className="city-row" style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', gap: 12 }}
                  onMouseOver={e => e.currentTarget.style.background = darkMode ? '#252b3b' : '#fafaf8'}
                  onMouseOut={e => e.currentTarget.style.background = 'transparent'}>
                  <div style={{ flex: 1 }}>
                    <div className="city-name" style={{ fontSize: 14, fontWeight: 500, color: '#1a1a1a' }}>{city.name}</div>
                    <div className="city-tz" style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{tzLabel(city.timezone)}</div>
                  </div>
                  <button className="btn-edit" onClick={() => startEdit(city)}
                    style={{ padding: '5px 10px', borderRadius: 7, background: 'transparent', border: '1px solid #e0e0dc', cursor: 'pointer', fontSize: 12, color: '#555' }}>
                    ✏ Изменить
                  </button>
                  <button onClick={() => handleDelete(city.id, city.name)}
                    style={{ padding: '5px 10px', borderRadius: 7, background: 'transparent', border: '1px solid #fca5a5', cursor: 'pointer', fontSize: 12, color: '#E24B4A' }}>
                    Удалить
                  </button>
                </div>
              )}
            </div>
          ))}

          {!loading && filtered.length === 0 && (
            <div style={{ padding: 24, textAlign: 'center', color: '#bbb', fontSize: 13 }}>Городов не найдено</div>
          )}
        </div>
      </main>
    </div>
  )
}